export default __webpack_public_path__ + "static/media/sparck-logo-transparent.2ed91a3f.png";